export default __webpack_public_path__ + "static/media/img-0664-albania-full-face.3dec3e18.png";